import { ThemeProvider } from "@emotion/react";
import { Box, createTheme, FormLabel, Paper } from "@mui/material";
import { SText } from "components";
import { STheme } from "components/styles";

type Props = {
  title: string;
  msg: string;
};
export const SConfirmDialog = (props: Props): JSX.Element => {
  return (
    <ThemeProvider theme={theme}>
      <Paper variant="outlined">
        <Box>
          <Box
            className="handle"
            display="grid"
            sx={{
              backgroundColor: STheme.frames.bar,
              borderColor: STheme.frames.border,
              borderBottomStyle: "solid",
              borderBottomWidth: "1px",
            }}
          >
            <FormLabel>{props.title}</FormLabel>
          </Box>
          <Box padding="3rem" paddingBottom="4rem" minHeight="2.5rem">
            <SText>{props.msg}</SText>
          </Box>
        </Box>
      </Paper>
    </ThemeProvider>
  );
};

const theme = createTheme(
  {
    components: {
      MuiFormLabel: {
        styleOverrides: {
          root: {
            padding: "5px 10px",
            color: STheme.frames.contrastText,
            fontSize: "1rem",
          },
        },
      },
    },
  },
  { ...STheme }
);
